interface BuildAuthSuccessRedirectUrlArgs {
  redirectUri: string;
  code: string;
  state: string;
  requestedPath?: string | null;
  grantType?: string | null;
}

const buildAuthSuccessRedirectUrl = ({
  redirectUri,
  code,
  state,
  requestedPath,
  grantType,
}: BuildAuthSuccessRedirectUrlArgs): string => {
  const separator = redirectUri.includes('?') ? '&' : '?';
  const params = new URLSearchParams({ code, state });
  if (requestedPath) {
    params.append('requestedPath', requestedPath);
  }
  if (grantType) {
    params.append('grantType', grantType);
  }
  return `${redirectUri}${separator}${params.toString()}`;
};

export default buildAuthSuccessRedirectUrl;
